export const SECONDUPSELLOPTIONS = {
    offerText: {
      optionName: "Offer Text",
      optionValue: "offerText",
      customizeProperties: {
        text: {
          propertyName: "Text",
          propertyType: "text",
          propertyMaxLength: "150",
          propertyValue:
            "Get an exclusive 10% off if you order in next 60 minutes!",
        },
        textColor: {
          propertyName: "Text-Color",
          propertyType: "color",
          propertyValue: "#000000",
        },
        fontStyle: {
          propertyName: "Font-Style",
          propertyType: "select",
          propertyValue: "normal",
          propertyOptions: [
            {
              optionName: "Normal",
              optionValue: "normal",
            },
            {
              optionName: "Italic",
              optionValue: "italic",
            },
            {
              optionName: "Oblique",
              optionValue: "oblique",
            },
          ],
        },
        fontFamily: {
            propertyName: 'Font-Family',
            propertyType: 'select',
            propertyValue: 'sans-serif',
            propertyOptions: [
              {
                optionName: "Serif",
                optionValue: "serif",
              },
              {
                optionName: "Cursive",
                optionValue: "cursive",
              },
              {
                optionName: "Sans-Serif",
                optionValue: "sans-serif",
              },
            ],
          },
      },
    },
    nudgeCouponCode: {
      optionName: "Nudge coupon code",
      optionValue: "nudgeCouponCode",
      customizeProperties: {
        text: {
          propertyName: "Text",
          propertyType: "text",
          propertyMaxLength: "20",
          propertyValue: "CFWELCOME23",
        },
        textColor: {
          propertyName: "Text-Color",
          propertyType: "color",
          propertyValue: "#ffffff",
        },
        backgroundColor: {
          propertyName: "Background-Color",
          propertyType: "color",
          propertyValue: "#990505",
        },
        fontStyle: {
          propertyName: "Font-Style",
          propertyType: "select",
          propertyValue: "normal",
          propertyOptions: [
            {
              optionName: "Normal",
              optionValue: "normal",
            },
            {
              optionName: "Italic",
              optionValue: "italic",
            },
            {
              optionName: "Oblique",
              optionValue: "oblique",
            },
          ],
        },
        borderStyle: {
          propertyName: "Border-Style",
          propertyType: "select",
          propertyValue: "solid",
          propertyOptions: [
            {
              optionName: "None",
              optionValue: "none",
            },
            {
              optionName: "Dotted",
              optionValue: "dotted",
            },
            {
              optionName: "Dashed",
              optionValue: "dashed",
            },
            {
              optionName: "Solid",
              optionValue: "solid",
            },
          ],
        },
        borderColor: {
          propertyName: "Border-Color",
          propertyType: "color",
          propertyValue: "#ffffff",
        },
        borderWidth: {
          propertyName: "Border-Width",
          propertyType: "number",
          propertyValue: 0,
        },
      },
    },
    nudgeCopyCode: {
      optionName: "Nudge Copy code",
      optionValue: "nudgeCopyCode",
      customizeProperties: {
        text: {
          propertyName: "Text",
          propertyType: "text",
          propertyMaxLength: "50",
          propertyValue: "COPY CODE",
        },
        textColor: {
          propertyName: "Text-Color",
          propertyType: "color",
          propertyValue: "#ffffff",
        },
        backgroundColor: {
          propertyName: "Background-Color",
          propertyType: "color",
          propertyValue: "#000000",
        },
        fontStyle: {
          propertyName: "Font-Style",
          propertyType: "select",
          propertyValue: "normal",
          propertyOptions: [
            {
              optionName: "Normal",
              optionValue: "normal",
            },
            {
              optionName: "Italic",
              optionValue: "italic",
            },
            {
              optionName: "Oblique",
              optionValue: "oblique",
            },
          ],
        },
        borderStyle: {
          propertyName: "Border-Style",
          propertyType: "select",
          propertyValue: "solid",
          propertyOptions: [
            {
              optionName: "None",
              optionValue: "none",
            },
            {
              optionName: "Dotted",
              optionValue: "dotted",
            },
            {
              optionName: "Dashed",
              optionValue: "dashed",
            },
            {
              optionName: "Solid",
              optionValue: "solid",
            },
          ],
        },
        borderWidth: {
          propertyName: "Border-Width",
          propertyType: "number",
          propertyValue: 0,
        },
        borderColor: {
          propertyName: "Border-Color",
          propertyType: "color",
          propertyValue: "#ffffff",
        },
      },
    },
    nudge: {
      optionName: "Nudge",
      optionValue: "nudge",
      customizeProperties: {
        backgroundColor: {
          propertyName: "Background-Color",
          propertyType: "color",
          propertyValue: "#ffffff",
        },
        borderColor: {
          propertyName: "Border-Color",
          propertyType: "color",
          propertyValue: "#ffffff",
        },
        borderStyle: {
          propertyName: "Border-Style",
          propertyType: "select",
          propertyValue: "solid",
          propertyOptions: [
            {
              optionName: "None",
              optionValue: "none",
            },
            {
              optionName: "Dotted",
              optionValue: "dotted",
            },
            {
              optionName: "Dashed",
              optionValue: "dashed",
            },
            {
              optionName: "Solid",
              optionValue: "solid",
            },
          ],
        },
        borderWidth: {
          propertyName: "Border-Width",
          propertyType: "number",
          propertyValue: 0,
        },
      },
      nudgePosition: {
        optionName: "Nudge Position",
        optionValue: "nudgePosition",
        customizeProperties: {
          left: 0
        }
      }
    },
  };